export default __webpack_public_path__ + "static/media/14548.accountancy-day-committee.photo.e21bb0fa.jpg";